// A fingerprint as chips of four hex digits (design/isomorphic/src/pages/device-cards.tsx). The
// groups are separated by real spaces, so the text reads and copies as "71f4 c2a9 …".
import { Fragment } from "react";

import { cn } from "../ui/cn";

const CHIP = {
  sm: "rounded-md bg-gray-100 px-2 py-1 font-mono text-[12.5px] font-medium text-gray-800",
  lg: "rounded-lg border border-muted bg-gray-50 px-3 py-2 font-mono text-xl font-semibold tracking-wider text-gray-900 dark:bg-gray-100",
};

export function FingerprintChips({ value, size = "sm", testId, className }: { value: string; size?: keyof typeof CHIP; testId?: string; className?: string }) {
  const groups = value.split(" ").filter(Boolean);
  return (
    <div data-testid={testId} className={cn("flex flex-wrap", size === "lg" ? "justify-center gap-2" : "gap-1.5", className)}>
      {groups.map((g, i) => (
        <Fragment key={i}>
          {i > 0 ? " " : null}
          <span className={CHIP[size]}>{g}</span>
        </Fragment>
      ))}
    </div>
  );
}
